/** Focus the visible Select trigger inside a FormControl. MUI renders it with
 * role="combobox" — querying the FormControl wrapper gets us the right node
 * regardless of any internal markup shuffling between MUI versions. */
export function focusSelectTrigger(controlRef: React.RefObject<HTMLDivElement>): void {
    const trigger = controlRef.current?.querySelector<HTMLElement>('[role="combobox"]');
    trigger?.focus();
}
